import type { ProductActionItem } from "../types/product-actions.types";

export const PRODUCT_ACTIONS: ProductActionItem[] = [
	{ key: "download_report", label: "Download Report", icon: "Download" },
	{ key: "download_summary", label: "Download Summary", icon: "Download" },
	{ key: "version_history", label: "Version History", icon: "History" },
];
